import { render, staticRenderFns } from "./TooltipBZ.vue?vue&type=template&id=0daf7d7f&scoped=true"
import script from "./TooltipBZ.vue?vue&type=script&lang=js"
export * from "./TooltipBZ.vue?vue&type=script&lang=js"
import style0 from "./TooltipBZ.vue?vue&type=style&index=0&id=0daf7d7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daf7d7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
